/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
const autoModelApis = {
  /**
   * 自动化短信触达（尊享版自动化营销）
   */
  getAutoMarketList: {  // 获取自动化营销首页的模板
    url: '/automodemarketcommon/index',
    method: 'GET',
  },
  checkModelWhite: { // 校验当前模板是否对商家开白，可以直接创建
    url: '/automodemarketcommon/check/{modelId}',
    method: 'GET',
    hasPathParams: true,
  },
  autoModemarketCampaign: {  // 获取活动列表
    url: '/cyclepurchase/tasks',
    method: 'GET'
  },
  stopAutoModemarketCampaign: { // 停止活动
    url: '/cyclepurchase/task/{id}',
    method: 'DELETE',
    hasPathParams: true,
  },
  getCampaignModelType: {   // 获取推送模型类型
    url: '/automodemarketcommon/campaignmodel',
    method: 'GET'
  },
  setAutoNewCompaign: { // 新建自动化营销活动
    url: '/cyclepurchase/tasks',
    method: 'POST',
  },
  checkAutoNewCompaign: { // 查看自动化营销活动
    url: '/cyclepurchase/campaign/{id}',
    method: 'GET',
    hasPathParams: true,
  },
  calcAutoMarket: { // 自动化营销-人群预计算
    url: '/automodemarketcrowd/compute',
    method: 'POST',
  },
  getAutoModelMarketExcuteLog: {   // 获取执行日志列表
    url: '/cyclepurchase/execute/log',
    method: 'GET'
  },
  getTaskDetails: {   // 任务成功/失败详细
    url: '/cyclepurchase/taskdetails',
    method: 'GET',
  },
  deleteAutoModeMarketTask: { //删除活动
    url: '/cyclepurchase/tasks',
    method: 'DELETE'
  },
}

const exportObj = {};
Object.keys(autoModelApis).forEach((key) => {
    exportObj[key] = {
        ...autoModelApis[key],
        url: `/api${autoModelApis[key].url}`
        // instanceName: 'marketing-request'
    }
});

export default exportObj;
